import React from "react";
import CommercialTop from "../../components/commercialRoofing/CommercialTop";
import CommercialMiddle from "../../components/commercialRoofing/CommercialMiddle";
import CommercialBottom from "../../components/commercialRoofing/CommercialBottom";
import Breadcrumb from "../../components/breadcrumb/Breadcrumb";

export default function Commercial() {
  return (
    <div>
      <CommercialTop />
      <Breadcrumb />
      <CommercialMiddle />
      <CommercialBottom />
    </div>
  );
}
